import { Box, Grid, Skeleton } from '@mui/material';

const GroupMemberLoading = () => {
    return (
        <Box sx={{ width: '100%' }}>
            <Grid container spacing={2}>
                {[...Array(6)].map((_, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <Skeleton
                            variant="rounded"
                            height={150}
                            animation="wave"
                        />
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default GroupMemberLoading; 